import { css, styled } from 'goober';
import React, { memo } from 'react';
import jioCinemaIcon from '../../../assets/jioCinemaIcon.webp';
import starImg from '../../../assets/star.webp';
import * as jio from '../../../constants/jioBannerConstants';
import State from '../../../state';
import font from '../../../styles/font';
/* stylelint-disable */
const jioBanner = css `
  position: absolute;
  background-color: white;
  height: 72px;
  width: 280px;
  left: 24px;
  bottom: 60px;
  border-radius: 10px;
`;
const JioCommonDiv = styled('div')(`
  position: absolute;
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: 700;
  `);
const jioTitle = css `
  height: 12px;
  width: 63px;
  left: 70px;
  line-height: 12px;
  letter-spacing: 0px;
  color: black;
  bottom: 50px;
`;
const JioDesciption = styled('p')(({ bottom, weight }) => `
  width: 13px;
  height: 10px;
  
  white-space: nowrap;
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-size: 8px;
  line-height: 10px;
  text-align: center;
  position: absolute;
  color: rgba(0, 0, 0, 0.8);
  bottom: ${bottom};
  font-weight: ${weight};
  `);
const JioItemContainer = styled('div')(`
position: absolute; 
left: 70px;
bottom: 0px;
`);
const jioIcon = css `
  position: absolute;
  width: 48px;
  height: 48px;
  left: 10px;
  bottom: 10px;
`;
const jioRatingIcon = css `
  height: 6.2px;
  width: 6.9px;
  left: 14px;
  bottom: 10.55px;
  border-radius: 0px;
  position: absolute;
`;
const jioDownloads = css `
  position: absolute;
  left: 25px;
`;
const jioInstall = css `
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px;
  font-size: 11px;
  position: absolute;
  width: 73px;
  height: 28px;
  right: 15px;
  bottom: 20px;
  background: #168d38;
  border: 1px solid #168d38;
  border-radius: 6px;
  white-space: nowrap;
`;
/* stylelint-enable */
const JioBanner = () => {
    return (React.createElement("div", { className: jioBanner, onClick: State.openApp },
        React.createElement("img", { className: jioIcon, src: jioCinemaIcon }),
        React.createElement(JioCommonDiv, { className: jioTitle }, jio.JIO_CINEMA_TITLE),
        React.createElement(JioItemContainer, null,
            React.createElement(JioDesciption, { bottom: '28px', weight: font.fontWtSemiBold }, jio.WORLD_CUP_MAIN_TEXT),
            React.createElement(JioDesciption, { bottom: '15px', weight: font.fontWtNormal }, jio.WORLD_CUP_SUB_TEXT),
            React.createElement("div", null,
                React.createElement(JioDesciption, { bottom: '0px', weight: font.fontWtSemiBold }, jio.APP_RATING),
                React.createElement("img", { className: jioRatingIcon, src: starImg })),
            React.createElement("div", { className: jioDownloads },
                React.createElement(JioDesciption, { bottom: '0px', weight: font.fontWtSemiBold },
                    "| ",
                    jio.APP_DOWNLOADS))),
        React.createElement("div", { className: jioInstall }, State.jioBannerButtonText)));
};
export default memo(JioBanner);
//# sourceMappingURL=index.js.map